<template>
  <div>
    <a-popover
      placement="bottomLeft"
      :get-popup-container="(trigger) => {return trigger.parentElement}"
      trigger="click"
      v-model="visible">
        <template slot="content">
          <div class="content-bg">
              <div class="dept-tree">
                <p class="title">选择部门</p>
                <a-tree :tree-data="deptsData" :replace-fields="{key: 'id', title: 'name', children: 'childrens'}" :defaultExpandedKeys="deptSelectedKeys" :selectedKeys="deptSelectedKeys" @select="deptSelected"></a-tree>
              </div>
              <div class="user-list-bg">
                <p class="title">选择用户</p>
                <a-list item-layout="vertical" :pagination="pagination" :data-source="userList">
                  <a-list-item slot="renderItem" slot-scope="item" @click="userSelected(item)">
                    <a style="display:block;">{{ item.nickName }}</a>
                    <a-icon v-if="item.id == userId" slot="extra" style="color:#409eff;" type="check" />
                  </a-list-item>
                </a-list>
              </div>
          </div>
        </template>
        <a-input :value="selectUser.nickName" :placeholder="placeholder" read-only :disabled="disabled" ></a-input>
    </a-popover>
  </div>
</template>

<script>
import { depts } from '@/api/dept'
import { users, get } from '@/api/user'
export default {
  name: 'user-select',
  model: {
    prop: 'userId',
    event: 'input'
  },
  props: {
    userId: Number,
    placeholder: {
      type: String,
      default: '点击选择'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      selectUser: {},
      deptsData: [],
      selectDeptId: null,
      deptSelectedKeys: [],
      userList: [],
      pagination: {
        onChange: (page, pageSize) => {
          var params = {
            deptId: this.selectDeptId,
            currentPage: page,
            pageSize: pageSize
          }
          this.getUsers(params)
        },
        pageSize: 10,
        simple: true,
        total: 0
      },
    }
  },
  components: {},
  mounted () {
    this.getDepts()
  },
  watch: {
    visible (newValue) {
        this.visible = newValue
        if (!newValue) {
          this.$emit('blur', this.selectUser.id)
        } else {
          if (this.selectDeptId) {
            var params = {
              deptId: this.selectDeptId,
              currentPage: 1,
              pageSize: this.pagination.pageSize
            }
            this.getUsers(params)
          }
        }
      },
      userId (newValue) {
        if (newValue) {
          get(newValue).then((data) => {
            if (data) {
              this.selectUser = data
              this.selectDeptId = data.deptId
              this.deptSelectedKeys = [data.deptId]
            }
          })
        } else {
          this.reset()
        }
      }
  },
  methods: {
    getDepts() {
      depts({name:''}).then((data) => {
        if (data) {
          this.deptsData = data
        }
      })
    },
    deptSelected (selectedKeys, e) {
      var deptId = selectedKeys[0]
      this.selectDeptId = deptId
      this.deptSelectedKeys = [deptId]
      var params = {
        deptId: deptId,
        currentPage: 1,
        pageSize: this.pagination.pageSize
      }
      this.getUsers(params)
    },
    getUsers (params) {
      users(params).then((data) => {
        if (data) {
          this.userList = data.list
          this.pagination.total = data.total
        }
      })
    },
    // 选中用户回调
    userSelected (user) {
      this.selectUser = user
      this.visible = false
      this.$emit('input', user.id)
      this.$emit('change', user.id)
      this.$emit('blur', user.id)
      this.$emit('username', user.userName)
      this.$emit('userInfo', user)
    },
    reset () {
      this.selectDeptId = null
      this.deptSelectedKeys = []
      this.selectUser = {}
      this.userList = []
    }
  }
}
</script>
<style lang="scss" scoped>
 @import "~@/styles/mixin.scss";
.content-bg {
  display: flex;
  height: 560px;
  overflow: hidden;
}
.dept-tree {
  width: 260px;
  height: 99%;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 10px;
  @include scrollBar;
}
.user-list-bg {
  width: 300px;
  height: 99%;
  padding: 0 10px;
}
.title {
  font-weight: 800;
}
</style>
